@use "../../../sass/global/global" as *;

$image-min-size: 214px;

/**
@prop --card-icon-size: Size of the icon (default `120px`)
@prop --card-image-size: Fixed size of the image in a horizontal card layout (default `214px`)
@Prop --card-image-min-height: Min height of the image in a horizontal card layout (default `214px`)
 */
:host {
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
    background: radial-gradient(
        127.42% 127.42% at 50% 50%,
        #fff 0%,
        #c3cfd6 100%
    );

    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        position: relative;
        overflow: hidden;
        padding: 0;
        margin: 0;
    }

    img,
    ::slotted(img) {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    ux-icon {
        font-size: var(--card-icon-size, 120px);
    }
}

:host-context([layout="vertical"]) {
    .container {
        aspect-ratio: var(--aspect-ratio, initial);
        height: auto;
    }
}

:host-context([layout="horizontal"]) {
    .container {
        width: var(--card-image-size, $image-min-size);
        min-height: var(
            --card-image-min-height,
            var(--card-image-size, $image-min-size)
        );
        aspect-ratio: initial;
        height: 100%;
    }

    img,
    ::slotted(img) {
        position: absolute;
        height: 100%;
    }
}
